import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.PtsOverzicht, {
  isVisible: (settings: EnvironmentSettings) => settings.isInterneGebruiker,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.PtsOverzicht,
    title: 'PTS overzicht',
    url: '/app/beurs/pts/dossiers',
    iconclass: 'fas fa-bullseye-arrow',
    target: '_top',
  }),
});
